import React from "react";

import { Skeleton } from "app/components/ui/skeleton";

export const StatusBadgeSkeleton = () => {
  return (
    <div className="flex items-center gap-1.5 sm:gap-2 md:gap-[0.625rem]">
      <Skeleton className="hidden sm:block h-4 sm:h-[1.125rem] md:h-6 w-[5.5rem] sm:w-[6.25rem] md:w-[6.5rem] rounded-md" />
      <Skeleton className="h-[1.375rem] sm:h-6 md:h-7 w-[4.625rem] sm:w-[5.625rem] md:w-24 rounded-2xl" />
    </div>
  );
};
